import React, { useEffect, useState } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import foxFace from "../../../Assets/Images/Trialpage/foxface.png";
import clickSound from "../../../Assets/sounds/click.mp3";

const Student_List = ({
  students,
  setSelectedStudent,
  selectedStudent,
  setStudentFlag,
}) => {
  const [audio] = useState(new Audio(clickSound));

  console.log("students", students);

  const handleButton = (id) => {
    // Play the click sound
    audio.currentTime = 0; // Reset audio to start
    audio.play().catch((err) => console.error("Error playing sound:", err));

    setSelectedStudent(id);
    setStudentFlag((prev) => !prev);
  };
  return (
    <div className="flex flex-col text-xl gap-1 h-full">
      {students?.map((student) => (
        <h1
          key={student.id}
          onClick={() => handleButton(student.id)}
          className={`cursor-pointer p-2 flex text-sm font-semibold text-gray-900 items-center transition-colors duration-200 ${
            selectedStudent === student.id
              ? "bg-blue-100 hover:bg-blue-200"
              : "hover:bg-gray-100"
          }`}>
          {/* Fox face indicators - now first section */}
          {/* <div className="flex justify-center items-center">
            {Array.from({ length: student.total_count }).map((_, index) => (
              <img
                key={index}
                src={foxFace}
                alt="Attempt"
                className={`w-6 h-6 ${
                  index >= student.remaining_count ? "grayscale opacity-90" : ""
                }`}
              />
            ))}
          </div> */}

          {/* Checkmark section - remains last */}
          <div className="w-1/6 flex justify-end">
            {student?.has_submitted && (
              <svg
                className="w-6 h-6 text-green-500"
                fill="currentColor"
                viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </div>

          {/* Student name - now middle section */}
          <div className="flex items-center gap-3 w-auto flex-1 ml-3">
            {student.user.name}
          </div>

          
        </h1>
      ))}
    </div>
  );
};

export default Student_List;
